export default {
    person: {
        name:'zhangsan',
        hobby:'Singing and dancing, rap, basketball'
    },
};